import { motion } from "framer-motion";
import { IMG } from "../lib/site";

export const ENGRAVING_FONTS = [
  {
    id: "estate-serif",
    name: "Estate Serif",
    desc: "Classic estate lettering",
    style: { fontFamily: "'Playfair Display', serif", fontStyle: "italic", fontWeight: 600 },
  },
  {
    id: "vintner-script",
    name: "Vintner Script",
    desc: "A hand-burned signature",
    style: { fontFamily: "'Great Vibes', cursive", fontWeight: 400 },
  },
  {
    id: "foundry-caps",
    name: "Foundry Caps",
    desc: "Architectural capitals",
    style: { fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 600, letterSpacing: "0.22em", textTransform: "uppercase" },
  },
  {
    id: "barrel-stamp",
    name: "Barrel Stamp",
    desc: "Distillery stamp style",
    style: { fontFamily: "'JetBrains Mono', monospace", fontWeight: 500, letterSpacing: "0.3em", textTransform: "uppercase" },
  },
];

export const EngravingPreview = ({ text, font }) => (
  <div data-testid="engraving-preview" className="relative overflow-hidden rounded-lg border border-stone-800">
    <img src={IMG.branding} alt="Barrel engraving preview" className="aspect-square w-full object-cover" />
    <div className="absolute inset-0 bg-black/45" />
    <div className="absolute inset-0 flex items-center justify-center px-4">
      <motion.p
        key={font.id + (text || "placeholder")}
        initial={{ opacity: 0, y: 8, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        data-testid="engraving-preview-text"
        className="max-w-[92%] text-center text-xl leading-snug text-amber-100 drop-shadow-[0_2px_8px_rgba(0,0,0,0.85)]"
        style={font.style}
      >
        {text || "Your Name Here"}
      </motion.p>
    </div>
    <p className="absolute bottom-2.5 left-3.5 font-mono text-[9px] uppercase tracking-[0.25em] text-amber-300/80">
      {font.name}
    </p>
  </div>
);
